import React, { useEffect } from 'react';
import { Price, Image } from '@boldcommerce/stacks-ui';
import { ICartItemProps } from 'src/types';
import { useGetCurrencyInformation, useCartItem, useGetCartParameters } from 'src/hooks';
import { SemiControlledNumberInput } from '../semi-controlled-number-input/semiControlledNumberInput';
import { getLineItemPropertiesForDisplay } from 'src/utils';
import { Constants } from 'src/constants';
import { deleteLineItem, getApplicationState } from '@bold-commerce/checkout-frontend-library';
import { getUpdatedApplicationState } from 'src/library';
import { useDispatch } from 'react-redux';
import { ProductSwatch } from '../custom/bigcommerce-swatch/bigcommerce-swatch';

export function CartItem({ line_item, quantityDisabled, onUpdateQuantity, showLineItemProperties = true, show_remove = true }: ICartItemProps): React.ReactElement {
    const { is_processed: isProcessed } = getApplicationState();

    console.log({ quantityDisabled, showLineItemProperties, show_remove, line_item })
    const { product_data } = line_item;
    const { formattedPrice } = useGetCurrencyInformation();
    const {
        decrementQuantity: decrementLocalQuantity,
        incrementQuantity: incrementLocalQuantity,
        updateQuantity: commit,
        quantity: localQuantity,
    } = useCartItem(
        line_item,
        quantityDisabled,
        onUpdateQuantity,
    );

    const dispatch = useDispatch();

    const cartParameters = useGetCartParameters();
    const properties = getLineItemPropertiesForDisplay(product_data.properties, cartParameters);

    const handleRemoveLineItem = async (line_item_key) => {
        await deleteLineItem({
            line_item_key: line_item_key,
            quantity: 0
        });
        await dispatch(getUpdatedApplicationState);
    }

    return (
        <li className="cart-item">
            <Image src={product_data.image_url} alt={product_data.product_title} className="cart-item__img-container cart-item__img-container--empty" />
            <div className="cart-item__text">
                <h2 className="cart-item__title">{product_data.product_title}</h2>
                {showLineItemProperties && properties.length > 0 ? (
                    <>
                        {!isProcessed ?
                            <ProductSwatch variantId={product_data.variant_id} lineItemKey={product_data.line_item_key} />
                            : ''}
                        {properties.map((property) => (
                            <React.Fragment key={property}>
                                <div className='cart-item__property'>{property}</div>
                            </React.Fragment>
                        ))}
                    </>
                ) : (
                    <>
                        {/* <p className="cart-item__variant-title">{product_data.title}</p> */}
                        {!isProcessed ?
                            <ProductSwatch variantId={product_data.variant_id} lineItemKey={product_data.line_item_key} />
                            : ''}
                    </>
                )}
            </div>
            <div className="cart-item__price-quantity">
                <div className="cart-item__quantity-container">
                    {onUpdateQuantity ? (
                        <div className="cart-item__quantity-controls">
                            {!quantityDisabled && !isProcessed ?
                                <>
                                    <button
                                        id={'quantity-decrease-button'}
                                        className="cart-item__quantity-decrease"
                                        aria-disabled={quantityDisabled}
                                        aria-label="decrement quantity"
                                        onClick={decrementLocalQuantity}
                                    >
                                        -
                                    </button>
                                    <SemiControlledNumberInput
                                        className="cart-item__quantity-input"
                                        min={1}
                                        value={localQuantity}
                                        aria-disabled={quantityDisabled}
                                        onCommit={commit}
                                    />
                                    <button
                                        id={'quantity-increase-button'}
                                        className="cart-item__quantity-increase"
                                        aria-disabled={quantityDisabled}
                                        aria-label="increment quantity"
                                        onClick={incrementLocalQuantity}
                                    >
                                        +
                                    </button>
                                </>
                                : ''}
                        </div>
                    ) : (
                        <div className="cart-item__quantity">
                            <span className="cart-item__quantity-number">{localQuantity}</span>
                        </div>
                    )}
                </div>
                <div className="cart-item__price"><Price amount={product_data.total_price} moneyFormatString={formattedPrice} textAlign="right" /></div>
                {!isProcessed && show_remove ?
                    <div className='cart-item__remove'>
                        <a href='#' onClick={() => handleRemoveLineItem(product_data.line_item_key)}>Remove</a>
                    </div>
                    : ''}
            </div>
        </li>
    );
}
